export default __webpack_public_path__ + "static/media/img_pow_right.511c573f.png";